import React from 'react'
import { TemplatePage } from '../../../../components/TemplatePage'
import { ScrollView, StyleSheet, Text, View } from 'react-native'
import { globalStyle } from '../../../../theme/global'
import { corporateColor, lightBackground, toqueColor, white } from '../../../../theme/colors'
import { Button } from '../../../../components/Button'
import { StackNavigationProp } from '@react-navigation/stack'
import { LogisticsRoutes, RootParams } from '../../../../navigator/types'
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { Separator } from '../../../../components/Separator'
import moment from 'moment'
import { DOBRA } from '../../../../theme/fonts'

interface Navigation extends StackNavigationProp<RootParams, 'LogisticsStack'> {}

export const Success = () => {
  const navigation = useNavigation<Navigation>()
  const { params } = useRoute<RouteProp<LogisticsRoutes, 'Success'>>()

  return (
    <TemplatePage styleContent={{ padding: 0, marginBottom: 0 }} header title='Consumo combustible'>
      <ScrollView
        style={[
          globalStyle.viewContainer,
          { paddingHorizontal: 16, backgroundColor: lightBackground },
        ]}
      >
        {params.naval_artifacts_summary.map((artifacts) => (
          <View style={style.cardContainer} key={artifacts.id_naval_artifact}>
            <Text style={style.title}>Parámetros {artifacts.name}</Text>
            <Separator
              customStyle={{ borderColor: toqueColor, borderWidth: 2, width: 31, marginTop: 4 }}
            />

            <Text style={style.bodyLabel}>
              Stock Inicial: {artifacts.initial_stock.toLocaleString('es-ES')} lt
            </Text>
            <Text style={[style.bodyLabel, { fontWeight: 'bold' }]}>
              Consumo: {artifacts.fuel_consumption} lt
            </Text>
            <Text style={style.bodyLabel}>
              Entrega programada: {artifacts.scheduled_delivery.toLocaleString('es-ES')}
            </Text>
            <Text style={style.bodyLabel}>
              Stock final: {artifacts.reported_stock.toLocaleString('es-ES')} lt
            </Text>
            <Text style={style.bodyLabel}>
              % Llenado inicio: {Math.round(artifacts.initial_state * 100)} %
            </Text>
            <Text style={style.bodyLabel}>
              % Llenado final: {Math.round(artifacts.final_state * 100)} %
            </Text>
            <Text style={style.bodyLabel}>
              Cobertura inicio: {artifacts.initial_coverage.toFixed(2)} días
            </Text>
            <Text style={style.bodyLabel}>
              Cobertura final: {artifacts.final_coverage.toFixed(2)} días
            </Text>

            <Separator />
            <Text style={style.title}>
              Autonomía final fecha: {moment(artifacts.autonomy_final_date).format('DD/MM/YYYY')}
            </Text>
          </View>
        ))}

        <View style={{ alignItems: 'center', marginBottom: 48 }}>
          <Button
            label='Volver'
            onPress={() => navigation.replace('HomeScreen')}
            variant='white'
            customStyle={{ width: 200 }}
          />
        </View>
      </ScrollView>
    </TemplatePage>
  )
}

const style = StyleSheet.create({
  cardContainer: {
    backgroundColor: white,
    borderRadius: 10,
    paddingHorizontal: 16,
    paddingVertical: 24,
    gap: 8,
    marginBottom: 16,
  },

  title: {
    fontFamily: DOBRA,
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: 20,
    color: corporateColor,
  },

  bodyLabel: {
    color: corporateColor,
    fontFamily: DOBRA,
    fontSize: 16,
    lineHeight: 20,
    fontWeight: '400',
  },
})
